import { Link } from 'react-router-dom';
import { Heart, Trash2, ShoppingCart, GitCompare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useWishlist } from '@/contexts/WishlistContext';
import { useCart } from '@/contexts/CartContext';

const WishlistPage = () => {
  const { items, removeFromWishlist, addToCompare, isInCompare, setIsCompareOpen } = useWishlist();
  const { addToCart } = useCart();

  if (items.length === 0) {
    return (
      <div className="container section-padding text-center">
        <Heart className="h-16 w-16 text-muted-foreground/30 mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold mb-2">Your Wishlist is Empty</h1>
        <p className="text-muted-foreground mb-6">Save products you love for later</p>
        <Link to="/products"><Button>Browse Products</Button></Link>
      </div>
    );
  }

  return (
    <div className="container section-padding">
      <h1 className="font-heading text-3xl font-bold mb-2">My Wishlist</h1>
      <p className="text-muted-foreground mb-8">{items.length} saved product{items.length !== 1 ? 's' : ''}</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map(product => (
          <div key={product.id} className="bg-card rounded-xl border shadow-sm overflow-hidden">
            <Link to={`/product/${product.id}`}>
              <img src={product.image} alt={product.name} className="w-full h-48 object-cover" loading="lazy" />
            </Link>
            <div className="p-4 space-y-2">
              <p className="text-xs text-muted-foreground uppercase">{product.brand}</p>
              <h3 className="font-heading font-semibold text-sm line-clamp-2">{product.name}</h3>
              <p className="font-heading font-bold">₹{product.price.toLocaleString('en-IN')}</p>
              <div className="flex gap-2 pt-1">
                <Button size="sm" className="flex-1 text-xs h-8" onClick={() => addToCart(product)}>
                  <ShoppingCart className="h-3 w-3 mr-1" /> Add
                </Button>
                <Button size="sm" variant="outline" className="h-8" onClick={() => { addToCompare(product); setIsCompareOpen(true); }} disabled={isInCompare(product.id)}>
                  <GitCompare className="h-3 w-3" />
                </Button>
                <Button size="sm" variant="ghost" className="h-8 text-destructive" onClick={() => removeFromWishlist(product.id)}>
                  <Trash2 className="h-3 w-3" />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WishlistPage;
